import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import cardRegister01 from "@/assets/images/help/card-register-01.png";
import cardRegister02 from "@/assets/images/help/card-register-02.png";
import cardRegister03 from "@/assets/images/help/card-register-03.png";
import cardRegister04 from "@/assets/images/help/card-register-04.png";
import cardRegister05 from "@/assets/images/help/card-register-05.png";

export default function HelpCardRegister() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">How to Register Your Card</h1>
        </div>

        {/* Introduction */}
        <div className="space-y-6 mb-8">
          <p className="text-sm font-semibold whitespace-pre-line">
            Register Your Fellas Card
            {"\n"}To use your Fellas Card, you need to register the physical
            card.
          </p>

          <div className="flex justify-center">
            <div className="m-4 rounded-lg overflow-hidden shadow-md inline-block rotate-[15deg]">
              <img src={cardRegister01} alt="Fellas Card" className="h-auto" />
            </div>
          </div>

          <p className="text-sm font-semibold whitespace-pre-line">
            Once registration is complete, you can immediately use the following
            features:
            {"\n"} · Card payments and top-ups
            {"\n"} · Secure transactions linked to your account
          </p>

          <p className="text-sm font-semibold whitespace-pre-line">
            After receiving your physical card, go to the Register screen.
            {"\n\n"}
            Complete email verification, then enter your card number and proxy
            number to finish the registration.
          </p>

          <div className="rounded-lg overflow-hidden shadow-md">
            <img
              src={cardRegister02}
              alt="Registration Screen"
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 1: Enter and Verify Account Email
            </h3>
            <p className="text-sm font-semibold whitespace-pre-line">
              Enter the email associated with your Fellas Card account.
              {"\n"}Check your email for the verification code and enter it to
              verify.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardRegister03}
                alt="Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 2: Enter Card Information
            </h3>
            <p className="text-sm font-semibold whitespace-pre-line">
              Enter your card number and proxy number.
              {"\n\n"}
              You can find these on the back of your card.
              {"\n\n"}
              The proxy number is the 12-digit number located at the bottom
              right of the card.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardRegister04}
                alt="Step 2"
                className="w-full h-auto"
              />
            </div>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardRegister05}
                alt="Card Back Reference"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg">
          <h3 className="text-lg font-bold opacity-90 mb-2">
            Step 3: Complete Card Registration
          </h3>
          <p className="text-sm font-semibold whitespace-pre-line">
            After entering all information, click the "Confirm" button to
            complete the card registration.
            {"\n\n"}
            Once registered, you can top up and use your card immediately.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/10")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Top Up Your Card</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
